<template>
  <login-layout :title="layoutTit">
    <div class="invite-login-tit">
      {{ $t('message["1241"]') }}
    </div>
    <div class="accout-login invite-login">
      <a-form
        :form="form"
        @submit.prevent="submitForm"
      >
        <a-form-item label="">
          <!-- <a-input
            v-decorator="decorators.username"
            placeholder="设置登录帐号"
          /> -->
          <a-popover
            title=""
            trigger="focus"
            overlay-class-name="input-tip-tip-box"
          >
            <template slot="content">
              <p>3-15{{ $t('message["369"]') }}</p>
            </template>
            <a-input
              v-decorator="decorators.username"
              :placeholder="setAccountPlace"
            />
          </a-popover>
        </a-form-item>
        <a-form-item label="">
          <!-- <a-input
            v-decorator="decorators.password"
            type="password"
            placeholder="设置密码"
          /> -->
          <a-popover
            title=""
            trigger="focus"
            overlay-class-name="input-tip-tip-box"
          >
            <template slot="content">
              <p>{{ $t('message["633"]') }}</p>
            </template>
            <a-input
              v-decorator="decorators.password"
              :placeholder="setPwdPlace"
              type="password"
            />
          </a-popover>
        </a-form-item>
        <a-form-item class="createUser">
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["1052"]') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </login-layout>
</template>
<script>
import LoginLayout from '@/components/pc/organization/invite/Link'
import { mapActions, mapState } from 'vuex'
export default {
  'name': 'InviteLogin',
  components: {
    LoginLayout
  },
  data () {
    return {
      inviteLogin: {
        mobile: this.$route.query.mobile,
        invitecode: this.$route.query.invitecode,
        ensecret: this.$route.query.ensecret
      },
      getCodeUrl2: ''
    }
  },
  computed: {
    ...mapState('team/invite', ['decorators']),
    setAccountPlace () {
      return this.$t('message["1015"]')
    },
    setPwdPlace () {
      return this.$t('message["1028"]')
    },
    layoutTit () {
      return this.$t('message["1381"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('team/invite', ['fetchSupplyUsersInfoInvite']),
    submitForm (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          values.form = this.form
          const obj = Object.assign(values, this.inviteLogin)
          const chain = await this.fetchSupplyUsersInfoInvite(obj)
          chain.fetch()
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped >
.invite-login-tit {
  height: 24px;
  line-height: 24px;
  padding: 8px 0;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;

  span {
    margin: 0 10px;
  }
}
.createUser {
  text-align: center;
}
.invite-login {
  padding-top: 30px;

  .login-btn {
    display: block;
    width: 100%;
  }
}
</style>
